import { render, staticRenderFns } from "./Deactivate.vue?vue&type=template&id=53b4bf99&scoped=true&"
import script from "./Deactivate.vue?vue&type=script&lang=js&"
export * from "./Deactivate.vue?vue&type=script&lang=js&"
import style0 from "./Deactivate.vue?vue&type=style&index=0&id=53b4bf99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b4bf99",
  null
  
)

export default component.exports